/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});